
import classNames from 'classnames';
import {Link} from 'react-router-dom';

export default function TextLink({text,to,className}){

    return(
        <Link className={classNames(className,"border rounded-full group px-5 py-1 border-medium-green hover:bg-medium-green")} to={to}>
            <p className={"font-medium group-hover:text-white text-medium-green"}>{text}</p>
        </Link>
    )
}